import { BannerFormContentText } from './BannerFormContentText'
import { BannerFormLocation } from './BannerFormLocation'
import { BannerFormLinkDestination } from './BannerFormLinkDestination'
import { BannerFormExperiment } from './BannerFormExperiment'
import { BannerFormDetail } from './BannerFormDetail'
import { BannerFormContentImage } from './BannerFormContentImage'
import { BannerFormContentImageInput } from './BannerFormContentImageInput'
import { BannerFormDetailScheduler } from './BannerFormScheduler'
import { FlyoutFormDestination } from './FlyoutFormDestination'
import { FlyoutFormContentText } from './FlyoutFormContentText'
// export * as components from '.'
export const FlyoutText = FlyoutFormContentText
export const ContentText = BannerFormContentText
export const Location = BannerFormLocation
export const LinkDestination = BannerFormLinkDestination
export const Experiment = BannerFormExperiment
export const Details = BannerFormDetail
export const ContentImage = BannerFormContentImage
export const ContentImageInput = BannerFormContentImageInput
export const Schedule = BannerFormDetailScheduler
export const FlyoutDestination = FlyoutFormDestination
